import { useSyncExternalStore } from 'react'

let _slug = ''
const _subs = new Set<() => void>()

export function setEsimSelection(slug: string) {
  _slug = slug
  _subs.forEach(fn => fn())
}

function subscribe(onStoreChange: () => void) {
  _subs.add(onStoreChange)
  return () => { _subs.delete(onStoreChange) }
}

const getSnapshot = () => _slug

// _slug is module state, so on the server it would be shared between requests.
// The selection is a click that has not happened yet at render time, so the
// server snapshot is always empty.
const getServerSnapshot = () => ''

export function useEsimSelection(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
